import styled, { x } from '@xstyled/styled-components';
import React, { FC, useEffect } from 'react';
import { shallow } from 'zustand/shallow';
import { select } from '~/lib/select';
import ArrowIcon from '~/assets/icons/curved-arrow.svg';
import {
  SequenceStore,
  useSequenceStore
} from '~/training/sequence/SequenceStore';
import { QuizMatchStore, useQuizMatchStore } from '../QuizMatchStore';
import { LeftMatch } from './LeftMatch';
import { RightMatch } from './RightMatch';
import { NextButton } from '~/ui/buttons';
import {
  GlobalMediaStore,
  useGlobalMediaStore
} from '~/ui/video-player/GlobalMediaProvider';
import { useNextSequence } from '~/training/useNextSequence';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';

const mediaSelector = (s: MediaPlayerStore) => select(s, 'status');
const selector = (s: QuizMatchStore) => select(s, 'leftItems', 'rightItems');
const sequenceSelector = (s: SequenceStore) =>
  select(s, 'addBlocker', 'removeBlocker');

const ArrowIconBlock = styled.div`
  position: absolute;
  left: 40%;
  right: 40%;
  svg {
    transform: rotate(33deg);
  }
  @media (max-width: sm) {
    display: none;
  }
`;

export const QuizMatchRoot: FC<{ id: string }> = ({ id }) => {
  const globalMedia = useGlobalMediaStore() as GlobalMediaStore;
  const globalPlayer = globalMedia?.player;
  const next = useNextSequence();

  const { status } = useMediaPlayerStore(mediaSelector, shallow);
  const { leftItems, rightItems } = useQuizMatchStore(selector, shallow);
  const { addBlocker, removeBlocker } = useSequenceStore(
    sequenceSelector,
    shallow
  );

  useEffect(() => {
    if (leftItems.length === 0) return;
    addBlocker(id);
    return () => removeBlocker(id);
  }, [leftItems.length]);

  const goNext = () => {
    if (globalPlayer) {
      globalPlayer.pause();
    }
    next();
  };

  return (
    <x.div
      w="100%"
      h="100%"
      p="xxl"
      display="grid"
      gridTemplateColumns="1fr 1fr"
    >
      <x.div
        display="flex"
        flexDirection="column"
        gap="md"
        alignItems="flex-start"
      >
        {leftItems.map(i => (
          <LeftMatch key={i.pairId} {...i} />
        ))}
      </x.div>
      <x.div
        display="flex"
        flexDirection="column"
        gap="md"
        alignItems="flex-end"
      >
        {rightItems.map(i => (
          <RightMatch key={i.pairId} {...i} />
        ))}
        {status === 'nomedia' || status === 'done' ? (
          <NextButton id="nextBtn2" onClick={goNext} />
        ) : null}
      </x.div>
      <ArrowIconBlock>
        <ArrowIcon />
      </ArrowIconBlock>
    </x.div>
  );
};
